// ------ PROCESS ENV VARIABLES ---------- //
export const BASE_SHOPS_PATH = "/shops";
export const BASE_DASHBOARD_PATH = "/dashboard";
export const PRODUCTS_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_PRODUCTS_GRAPHQL_API_BASE_URL;
export const REWARDS_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_REWARDS_API_BASE_URL;
export const USERS_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_USER_SERVICE_API_BASE_URL;
export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const IS_PRODUCTION = process.env.NEXT_PUBLIC_ENVIRONMENT === "production";
export const SM_PROGRAM_ID = process.env.NEXT_PUBLIC_SM_PROGRAM_ID;
export const STRIPE_API_KEY = process.env.NEXT_PUBLIC_STRIPE_API_KEY;
export const SM_API_HOST = process.env.NEXT_PUBLIC_SM_API_HOST;
export const LAUNCH_DARKYLY_CLIENT_ID = process.env.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_SIDE_ID;
export const SM_API_BASE_URL = `${SM_API_HOST}/api/v1/ams`;
export const SEARCH_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_SEARCH_API_BASE_URL;
export const PUBNUB_PUBLISH_KEY = process.env.NEXT_PUBLIC_PUBNUB_PUBLISH_KEY;
export const PUBNUB_SUBSCRIBE_KEY = process.env.NEXT_PUBLIC_PUBNUB_SUBSCRIBE_KEY;
export const GTM_SCRIPT_ID = process.env.NEXT_PUBLIC_GTM_SCRIPT_ID;
export const ZENDESK_KEY = process.env.NEXT_PUBLIC_ZENDESK_KEY;
export const GOOGLE_ANALYTICS_GA4_APPID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_GA4_APPID;
export const REWARDS_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_REWARDS_API_BASE_URL;
export const OSANO_ID = process.env.NEXT_PUBLIC_OSANO_ID;
export const BRAND_LOGO_FETCH_API_KEY = process.env.NEXT_PUBLIC_BRAND_LOGO_FETCH_API_KEY;
export const SHOPS_DASHBOARD_HOSTNAME = process.env.NEXT_PUBLIC_SHOPS_DASHBOARD_HOSTNAME;

export const POST_AUTH_REDIRECT_ROUTE = "/auth/post-auth";

export const WEGLOT_API_KEY = process.env.NEXT_PUBLIC_WEGLOT_API_KEY || "test-key";
export const HOME_URL = IS_DEVELOPMENT
  ? "http://localhost:3000"
  : `https://${process.env.NEXT_PUBLIC_DOMAIN}`;
export const STADIUM_USERS_URL = process.env.NEXT_PUBLIC_STADIUM_USERS_URL;
export const STADIUM_REWARDS_URL = process.env.NEXT_PUBLIC_STADIUM_REWARDS_URL;
// ------ PROCESS ENV VARIABLES ---------- //

export const FOOTER_PLATFORM = "Stadium";

export const USA_COUNTRY_ID = 232;

export const DEFAULT_COUNTRY_ISO = "US";

export const DEFAULT_CURRENCY_CODE = "USD";

export const EXCLUDED_CURRENCIES = ["STC"];

export const DEFAULT_CURRENCY_ID = 1;

export const DEFAULT_MAIL_HANDLER = "hi@bystadium.com";

export const DEFAULT_STC_CURRENCY = {
  code: "STC",
  name: "Pts",
  label: "Points",
};

export const ESHOPS = "shops";

export const REWARDS_POINTS_CURRENCY_CODE = "STC";

export const SM_PROGRAM_IDENTIFIER = "snacks";

export const APP_NAME = "stadium";

export const ZENDESK_POSITION_BOTTOM = "90px";

export const ZENDESK_POSITION_HIDE_BOTTOM = "-90px";

export const DEFAULT_FUNC = () => {
  return;
};

export const SPREE_PRODUCT_TYPE = "Spree::Product";

export const SPREE_PRODUCT_SET_TYPE = "Spree::ProductSet";

export const DEFAULT_ARRAY = [];

export const DATE_PICKER_FORMAT = "MM/DD/YYYY";

export const RLP_MESSAGE_MAX_LENGTH = 1500;

export const DEFAULT_SHOP_CODE = "stadium-gift-shop";
